export default function(el, iframe) {
    el && el.addEventListener('click', () => el.innerHTML = iframe);
}